/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { setToast } from '../../../store/ToastManagement';
import {
  Container,
  Grid,
  Segment,
  Header,
  Checkbox,
  Radio,
  Dropdown,
  Embed,
  Modal
} from 'semantic-ui-react';
import { Button } from 'formik-semantic-ui';
import { useCurrentUser } from '../../../_services/hooks/user';
import {
  authAPI,
  servicesAPI,
  useCustomer,
  useCustomerPreferences
} from '../../../_services';
import {
  AONLink,
  AONButton,
  AONCheckBox,
  AONRadioButtons,
  AONOnboardTask,
  AONTimeRange,
  AONNav
} from '../../../_components/layout/AON';

import '../customerDetail_styles.css';
import '../../../_components/layout/AON.css';

const Config = require('../../../conf');

export const HUBToAONEOIApproved = () => {
  return (
    <Container>
      <Grid centered padded>
        <Grid.Column style={{ maxWidth: 880 }}>
          <Segment>
            <div className="aon-modal">
              <div className="aon-frame">
                <div className="aon-text-box">
                  <span className="aon-text-box-span-bold">
                    HUB Conversion To Home: EOI Approved
                  </span>
                </div>
              </div>
            </div>
          </Segment>
        </Grid.Column>
      </Grid>
    </Container>
  );
};
